export const setUserData = (userData: { token: string; refreshToken: string; user: any; }) => 
    {
      localStorage.setItem("token", userData.token);
      localStorage.setItem("refreshToken", userData.refreshToken);
      if(userData.user)
      {
        localStorage.setItem("user", JSON.stringify(userData.user));
      }
    };
    
    export const setToken = (token: string) => 
    {
      localStorage.setItem("token", token);
    };
    
    export const setUser = (userProfile: string) =>
    {
        localStorage.setItem("user", userProfile);
    }
    
    export const getToken = () => localStorage.getItem("token");
    
    export const getRefreshToken = () => localStorage.getItem("refreshToken");
    
    export const isTokenExpired = () => 
    {
      const token = getToken();
        if (!token) 
        {
            return true;
        }
      const result = decodeJWT(token);
      return Date.now() > result.payload.exp * 1000;
    
    }
    
    export const getUser = () => 
    {
        var user = localStorage.getItem("user");
        if(user)
        {
            return JSON.parse(user);
        }
       return null;
    }
    
    export const setCreditAmount = (creditAmount: any) => 
    {
        var user = localStorage.getItem("user");
        if(user)
        {
            var userData = JSON.parse(user);
            if(creditAmount)
            {
              userData.creditAmount = creditAmount;
              localStorage.setItem("user", JSON.stringify(userData));
            }       
        }
    }
    
    export const isTokenValid = () => {
      const token = getToken();
      const refreshToken = getRefreshToken();
      if (!token)
      {
         return false;
      }
      else
      {
        try
        {
          const result = decodeJWT(token);
          const isTokenExpired = Date.now() > result.payload.exp * 1000;
          if(!refreshToken && isTokenExpired)
          {
            return false;
          }
          return true;
        }
        catch
        {
          return false;
        }
      }
    };
    
    export const clearToken = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
    };
    
    export const decodeJWT = (jwt: string ) => {
      try {
        const [header, payload, signature] = jwt.split(".");
    
        if (!header || !payload) {
          throw new Error("Invalid JWT format");
        }
    
        const decodedHeader = JSON.parse(atob(header));
        const decodedPayload = JSON.parse(atob(payload));
    
        return {
          header: decodedHeader,
          payload: decodedPayload,
          signature,
        };
      } 
      catch (err) 
      {
        throw new Error("Failed to decode JWT: " + (err as Error).message);
      }
    };
    